.root {
    composes: safeContainer from "../../styles/composable/layout.module.css";
    display: block;
    position: relative;
}

.styleVertical,
.styleHorizontal {
    &::after {
        content: "";
        position: absolute;
        background: var(--line-color);
    }
}

.styleVertical::after {
    left: 50%;
    inset-block: 20px;
    width: 1px;
}

.styleHorizontal::after {
    top: 50%;
    inset-inline: 0;
    height: 1px;
}

.colorAccent {
    --line-color: var(--accent);
}

.colorContrast {
    --line-color: var(--color-contrast);
}

.colorGray300 {
    --line-color: var(--gray-300);
}
